let id = 0

export default function uniqueId() {
  id++
  return id
}
